import React, { useMemo } from 'react';
import Chart from 'react-google-charts';
import Loading from '../ui/loading/Loading.js';
import Loadable from '../ui/loading/Loadable.js';
import convert from 'convert-units';


export default (props) => {
	const prepare = () =>  [['Type', 'Amount']].concat(Object.keys(props.data).map((x)=>[x, Math.round(convert(props.data[x]).from('kg').to(props.units || 'kg'))]));
	//if (props.units === null || props.units === false) return null;
	if (Object.keys(props.data).length === 0) return <p>No harvest data found found.</p>;
	return <div className="CostsBarChart">
		<Loadable ready={props.units !== null && props.units !== false && props.data !== false}>
		<Chart
			chartType="BarChart"
			width="100%"
			height="100%"
			loader={<Loading />}
			data={prepare()}
			options={{
				title: "Harvest totals in " + props.units,
				legend: {position: "none"},
				backgroundColor: { fill:'transparent' },
			}}
		/>
		</Loadable>
	</div>;
}